module.exports = __webpack_public_path__ + "assets/img/device.776aca05.png";